import React from 'react';

const DevicesPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true
			}
		}
	},
	routes: [
		{
			path: '/admin/devices',
			exact: true,
			component: React.lazy(() => import('./DevicesPage'))
		}
	]
};

export default DevicesPageConfig;
